"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var BlackElement = /** @class */ (function () {
    function BlackElement() {
        BlackElement.elements = document.querySelectorAll("[".concat(constants_1.DATA_BLACK_ELEMENT, "]"));
        if (!(BlackElement.elements.length > 0))
            return;
        BlackElement.themeColor = document.head.querySelector('meta[name="theme-color"]');
        BlackElement.background = document.createElement('div');
        BlackElement.background.classList.add('body-background', 'position-fixed');
        document.body.prepend(BlackElement.background);
        BlackElement.elements.forEach(function (element) {
            BlackElement.toggleBackground(element);
            document.addEventListener('scroll', function () {
                BlackElement.toggleBackground(element);
            });
        });
    }
    BlackElement.toggleBackground = function (element) {
        var _a, _b, _c, _d;
        var top = element.getBoundingClientRect().top;
        var elHeight = element.offsetHeight;
        var windowHeight = window.innerHeight;
        var bottom = Math.round(top + elHeight);
        var index = this.elementsInView.indexOf(element);
        if (top < 2 / 3 * windowHeight && bottom > 1 / 3 * windowHeight) {
            if (index < 0)
                this.elementsInView.push(element);
        }
        else {
            if (index > -1)
                this.elementsInView.splice(index, 1);
        }
        if (this.elementsInView.length > 0) {
            (_a = this.background) === null || _a === void 0 ? void 0 : _a.classList.add('z-index--2', 'bg-black');
            this.elements.forEach(function (element) {
                element.classList.add('text-white', 'z-index--3');
                BlackElement.prevAndNextElement(element, '-1');
            });
            (_b = this.themeColor) === null || _b === void 0 ? void 0 : _b.setAttribute('content', '#000000');
        }
        else {
            (_c = this.background) === null || _c === void 0 ? void 0 : _c.classList.remove('z-index--2', 'bg-black');
            this.elements.forEach(function (element) {
                element.classList.remove('text-white', 'z-index--3');
                BlackElement.prevAndNextElement(element);
            });
            (_d = this.themeColor) === null || _d === void 0 ? void 0 : _d.setAttribute('content', '#FFFFFF');
        }
    };
    BlackElement.prevAndNextElement = function (element, value) {
        if (value === void 0) { value = ''; }
        var prevEl = element.previousElementSibling;
        var nextEl = element.nextElementSibling;
        if (prevEl) {
            if (!prevEl.dataset.blackElement) {
                prevEl.style.zIndex = value;
            }
        }
        if (nextEl) {
            if (!nextEl.dataset.blackElement) {
                nextEl.style.zIndex = value;
            }
        }
    };
    BlackElement.elementsInView = [];
    return BlackElement;
}());
exports.default = BlackElement;
